import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('App error boundary caught:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            background: '#09090b',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            fontFamily: 'system-ui, -apple-system, sans-serif',
          }}
          data-testid="app-error-boundary"
        >
          <div style={{ maxWidth: 480, textAlign: 'center' }}>
            <div
              style={{
                fontSize: 48,
                marginBottom: 16,
                color: '#ccff00',
              }}
            >
              ⚠
            </div>
            <h1 style={{ fontSize: 24, fontWeight: 900, marginBottom: 12 }}>
              Algo ha ido mal
            </h1>
            <p style={{ color: '#a1a1aa', marginBottom: 24, lineHeight: 1.6 }}>
              Si tienes el traductor de Chrome activado en esta página, desactívalo
              (clic derecho → "Mostrar siempre el inglés/español original") y recarga.
            </p>
            <button
              onClick={this.handleReload}
              style={{
                background: '#ccff00',
                color: '#000',
                fontWeight: 700,
                padding: '12px 24px',
                borderRadius: 8,
                border: 'none',
                cursor: 'pointer',
                fontSize: 14,
              }}
              data-testid="error-boundary-reload"
            >
              Recargar página
            </button>
            {this.state.error?.message && (
              <pre
                style={{
                  marginTop: 24,
                  textAlign: 'left',
                  background: '#18181b',
                  padding: 12,
                  borderRadius: 6,
                  fontSize: 11,
                  color: '#71717a',
                  overflow: 'auto',
                  maxHeight: 120,
                }}
              >
                {this.state.error.message}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
